// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2KPXY","head":"ProcedureTableInfo_head__2p1rR"};